import { Box, Grid, Typography } from "@mui/material";
import { Fade } from "react-awesome-reveal";
import { Bolt, ShieldCheck, Leaf } from "lucide-react"; 
import { useInView } from 'react-intersection-observer'; 

const About = () => {
  const { ref, inView } = useInView({ triggerOnce: false, threshold: 0.8 }); 

  return (
    <>
         <Box
               ref={ref} // تأكد من إضافة هذا السطر
               id="about"


    sx={{
      backgroundImage: {
      xs:`url(/Phone2.png)`,
      md:`url(/tt.png)`,
      },
      marginTop:'20px',
      backgroundAttachment:'fixed',
      backgroundPosition:'center',
      backgroundOrigin:"content-box",
      backgroundPositionY:'center',
      backgroundSize: {
        xs:'contain',
        md:'contain'
      }, 
        width: '100%',  
        height:{
          xs:'20vh',
          md:'30vh'
        }


    }}
    >
   

    </Box>
 
    <Box


      sx={{
        position: "relative",
        padding: { xs: 3, md: 6 },
        background: "linear-gradient(to right, #ece9e6, #ffffff)",
        overflow: "hidden",
      }}
    >
     

      <Grid container spacing={4} alignItems="center">
        <Grid item xs={12} md={6}>
          <Fade direction="left" triggerOnce={false} in={inView}>
            <Box sx={{ padding: { xs: 2, md: 4 } }}>
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "bold",
                  color: "#333",
                  textTransform: "uppercase",
                  marginBottom: 2,
                  fontFamily: "Roboto Slab, serif",
                }}
              >
                Wer wir sind?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  color: "#555",
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                  marginBottom: 3,
                }}
              >
                Bei{" "}
                <span
                  style={{
                    color: "#FD0B0B",
                    fontWeight: "bold",
                  }}
                >
                  EMN Elektrotechnik
                </span>{" "}
                stehen wir für innovative und hochwertige Lösungen im Bereich
                Elektrotechnik. Unser Ziel ist es, Ihr Leben sicherer,
                einfacher und intelligenter zu machen.
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  lineHeight: 1.8,
                  color: "#555",
                  fontSize: { xs: "1rem", sm: "1.1rem" },
                }}
              >
                <strong
                  style={{
                    color: "#FD0B0B",
                    fontWeight: "bold",
                  }}
                >
                  Nachhaltigkeit und Sicherheit
                </strong>{" "}
                stehen im Mittelpunkt unserer Arbeit. Wir fördern den Einsatz
                erneuerbarer Energien und achten auf höchste
                Sicherheitsstandards in allen unseren Projekten.
              </Typography>
            </Box>
          </Fade>
        </Grid>

        <Grid item xs={12} md={5}>
          <Fade direction="right" triggerOnce={false} in={inView}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <img
                src="About.jpg" 
                alt="Electric Services"
                style={{
                  maxWidth: "100%",
                  borderRadius: "12px",
                  boxShadow: "0 8px 20px rgba(0, 0, 0, 0.15)",
                }}
              />
            </Box>
          </Fade>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          marginTop: 6,
          flexWrap: "wrap",
          gap: 4,
        }}
      >
        <Fade cascade direction="up" triggerOnce={false} in={inView}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Bolt size={48} color="#FF5722" />
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                marginTop: 2,
                color: "#333",
              }}
            >
              Innovation
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#555",
                textAlign: "center",
                maxWidth: "200px",
              }}
            >
              Maßgeschneiderte, innovative Lösungen, die modernste
              Technologien integrieren.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <ShieldCheck size={48} color="#4CAF50" />
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                marginTop: 2,
                color: "#333",
              }}
            >
              Sicherheit
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#555",
                textAlign: "center",
                maxWidth: "200px",
              }}
            >
              Höchste Sicherheits- und Qualitätsstandards in allen Projekten.
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Leaf size={48} color="#3F51B5" />
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                marginTop: 2,
                color: "#333",
              }}
            >
              Nachhaltigkeit
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#555",
                textAlign: "center",
                maxWidth: "200px",
              }}
            >
              Umweltfreundliche Lösungen, die erneuerbare Energien
              unterstützen.
            </Typography>
          </Box>
        </Fade>
      </Box>


    
    </Box>
    </>
  
  );
};

export default About;
